<template>
  <v-slide-group>
    <v-row justify="space-around">
      <v-slide-item v-for="(category, i) in categories" :key="i">
        <v-col cols="auto">
          <v-card
            :ripple="false"
            flat
            tile
            color="transparent"
            max-width="80"
            :to="{
              name: 'categoryTemplate',
              params: {
                category_id: category.id,
                category_name: slugify(category.category_name)
              }
            }"
          >
            <v-img width="80" height="80" :src="category.image" />
            <v-card-actions class="text-center text-caption text--secondary">
              {{ category.category_name }}
            </v-card-actions>
          </v-card>
        </v-col>
      </v-slide-item>
    </v-row>
  </v-slide-group>
</template>

<script>
export default {
  name: "CardCategorySlider",
  props: {
    categories: { type: Array, required: true }
  },
  serverCacheKey: props => props.categories.length
};
</script>
